const columns = [
  'bahai_areaagencyid',
  'bahai_rolecode',
  'bahai_typecode',
  'bahai_name',
  'bahai_rolephone',
  'bahai_cellphon',
  'bahai_roleemail',
  'bahai_cityid',
  'bahai_personalemail',
  'bahai_rolestartdate',
  'bahai_highlight',
  'bahai_emailaddress1',
  'bahai_emailaddress2',
] as const;

export default { columns, fields: [] };
